import { render, staticRenderFns } from "./PersonalProfileDetailsModal.vue?vue&type=template&id=4f9fad75&scoped=true&"
import script from "./PersonalProfileDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9fad75",
  null
  
)

export default component.exports